import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import Product from './pages/Product';
import Pricing from './pages/Pricing';
import Team from './pages/Team';
import Contact from './pages/Contact';
import TechnicalReport from './pages/TechnicalReport';
import SolutionCRO from './pages/SolutionCRO';
import SolutionSites from './pages/SolutionSites';
import SolutionPatients from './pages/SolutionPatients';
import KiraLanding from './pages/KiraLanding';
import Documentation from './pages/Documentation';
import './styles/globals.css';
import './styles/scroll-animations.css';

const AppContent: React.FC = () => {
  const location = useLocation();
  const isDocsPage = location.pathname === '/docs/vc';

  return (
    <div className="App">
      {!isDocsPage && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/technical-report" element={<TechnicalReport />} />
          <Route path="/kira" element={<KiraLanding />} />
          <Route path="/solution/cro" element={<SolutionCRO />} />
          <Route path="/solution/sites" element={<SolutionSites />} />
          <Route path="/solution/patients" element={<SolutionPatients />} />
          {/* Documentation - Hidden route for VC access */}
          <Route path="/docs/vc" element={<Documentation />} />
        </Routes>
      </main>
      {!isDocsPage && <Footer />}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
